module.exports = {
          srcSet: __webpack_public_path__ + "87531d7a863f1a02b94d3049bd913e40-1920.png"+" 1920w",
          images:[ {path: __webpack_public_path__ + "87531d7a863f1a02b94d3049bd913e40-1920.png",width: 1920,height: 594}],
          src: __webpack_public_path__ + "87531d7a863f1a02b94d3049bd913e40-1920.png",
          toString:function(){return __webpack_public_path__ + "87531d7a863f1a02b94d3049bd913e40-1920.png"},
          
          width: 1920,
          height: 594
        }